<template>
    <div>
        <div>
            <vue-headful title="Subcontractor Status Help :: MeritEHS"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        Status Help ({{ statuses.length }})
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8 col-md-7">
                    <div v-if="loading">
                        <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <div v-else>
                        <div class="card mb-3">
                            <div class="card-header">
                                Status Descriptions
                            </div>
                            <div class="card-body">
                                <ul class="list-unstyled">
                                    <li v-for="status in statuses" class="mb-4">
                                        <span :class="`badge badge-${status.status_color}`">{{ status.status_name }}</span>
                                        <ul>
                                            <li>{{ status.status_desc }}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                loading: true,
                statuses: [],
            }
        },

        methods: {
            //Get the status
            getStatuses(){
                //Send it
                this.$http.get('subcontractors/statuses', {type: 'help'})
                    .then(response => {
                        //Set the status
                        this.statuses = response.data;
                    })
                    .catch(err => {
                        //Alert the user
                    })
                    .then(response => {
                        //Helper
                        this.loading = false;
                    });
            }
        },

        mounted(){
            //Fetch the Statuses
            this.getStatuses();
        }
    }
</script>
